import * as FiIcons from 'react-icons/fi';
import {GatherTool,GatherVisual} from './CashflowGatherStep';
import {BaselineTool,BaselineVisual} from './BaselineStep';
import {MiniEfTool,MiniEfVisual,FullEfTool,FullEfVisual} from './EmergencySteps';
import {FiNumberTool,FiNumberVisual,AlignTool,AlignVisual} from './TargetSteps';
import {MatchTool,MatchVisual,DebtTool,DebtVisual} from './InfoSteps';
import {TaxTool,TaxVisual,BridgeTool,BridgeVisual,LeverTool,LeverVisual,ReviewTool,ReviewVisual} from './StrategySteps';

const {FiFileText,FiSettings,FiShield,FiBriefcase,FiTrendingDown,FiUmbrella,FiTarget,FiActivity,FiLayers,FiUnlock,FiZap,FiRefreshCw}=FiIcons;

export const WALKTHROUGH_STEPS=[
  {
    id: 'gather',roadmapId: null,label: 'Pre-Step • 3-Month Baseline',title: 'Gather 3 Months of Expenses',
    icon: FiFileText,color: 'amber',Tool: GatherTool,Visual: GatherVisual,
    description: 'Before setting goals, get an honest picture of your cash flow. Pull the last 3 months of bank and credit card statements, then enter your income and expenses. Tag each expense as Required or Discretionary to spot spending that may be slowing your long-term goals. Everything you add here also appears in your Budget.'
  },
  {
    id: 'setup',roadmapId: 'setup',label: 'Step 1 • Parameters',title: 'Strategic Baseline',
    icon: FiSettings,color: 'slate',Tool: BaselineTool,Visual: BaselineVisual,
    description: 'Define your financial foundation. These parameters dictate the speed of your journey to independence and populate the goal bar at the top of your dashboard as you type.'
  },
  {
    id: 'mini_ef',roadmapId: 'mini_ef',label: 'Step 2 • Starter Emergency Fund',title: 'Starter Emergency Fund',
    icon: FiShield,color: 'indigo',Tool: MiniEfTool,Visual: MiniEfVisual,
    description: 'Save a starter emergency fund of $1,000. This covers minor unexpected costs without going into debt while you tackle liabilities.'
  },
  {
    id: 'match',roadmapId: 'match',label: 'Step 3 • Free Money',title: 'Employer Match',
    icon: FiBriefcase,color: 'emerald',Tool: MatchTool,Visual: MatchVisual,
    description: 'A match is a guaranteed, immediate return on your money. Grab the full employer match before investing anywhere else. Never leave free money on the table.'
  },
  {
    id: 'debt',roadmapId: 'debt',label: 'Step 4 • ROI Strategy',title: 'Debt Eradication',
    icon: FiTrendingDown,color: 'rose',Tool: DebtTool,Visual: DebtVisual,
    description: 'Eradicate high-interest debt and optimise mortgage efficiency using strategic double-principal and biweekly payment modelling.'
  },
  {
    id: 'full_ef',roadmapId: 'full_ef',label: 'Step 5 • Stability',title: 'Full Emergency Fund',
    icon: FiUmbrella,color: 'indigo',Tool: FullEfTool,Visual: FullEfVisual,
    description: 'Build your safety net to 3-6 months of expenses so you never have to touch investments during a downturn. Enter your monthly expenses below.'
  },
  {
    id: 'fi_number',roadmapId: 'fi_number',label: 'Step 6 • The Target',title: 'Calculate FI Number',
    icon: FiTarget,color: 'purple',Tool: FiNumberTool,Visual: FiNumberVisual,
    description: 'Financial Independence is the point where your assets generate enough yield to cover your life. Standard 25x is based on the 4% safe withdrawal rate; 28x is more conservative. Your selection sets the target line on your chart.'
  },
  {
    id: 'req_savings',roadmapId: 'req_savings',label: 'Step 7 • Trajectory',title: 'Strategic Alignment',
    icon: FiActivity,color: 'orange',Tool: AlignTool,Visual: AlignVisual,
    description: 'Compare your current monthly velocity against the monthly contribution required to reach your FI number by your target age. All figures below are per month.'
  },
  {
    id: 'account_order',roadmapId: 'account_order',label: 'Step 8 • Efficiency',title: 'Tax Optimization',
    icon: FiLayers,color: 'blue',Tool: TaxTool,Visual: TaxVisual,
    description: 'Fill tax-advantaged buckets in order. We recommend Fidelity for unified management. Strategic tax placement can save you hundreds of thousands over your investing lifetime.'
  },
  {
    id: 'bridge',roadmapId: 'bridge',label: 'Step 9 • Penalties',title: 'Early Retirement Bridge',
    icon: FiUnlock,color: 'teal',Tool: BridgeTool,Visual: BridgeVisual,
    description: 'To retire before 59.5 you need a way to reach retirement accounts penalty-free. The Roth Conversion Ladder needs a 5-year seasoning period, so planning must start early.'
  },
  {
    id: 'income_lever',roadmapId: 'income_lever',label: 'Step 10 • Acceleration',title: 'The Income Lever',
    icon: FiZap,color: 'amber',Tool: LeverTool,Visual: LeverVisual,
    description: 'If your trajectory is slow, pull the income lever. You can only cut expenses so far, but income potential is far larger. Add any new income below and it flows straight into your Budget.'
  },
  {
    id: 'checkpoint',roadmapId: 'checkpoint',label: 'Step 11 • Maintenance',title: 'Annual Review',
    icon: FiRefreshCw,color: 'slate',Tool: ReviewTool,Visual: ReviewVisual,
    description: 'Re-run these numbers every 12 months to account for life changes, lifestyle inflation and market realities. Your FI number is a moving target that needs annual calibration.'
  }
];